import { render, staticRenderFns } from "./LensCreationModal.vue?vue&type=template&id=058f169a&scoped=true"
import script from "./LensCreationModal.vue?vue&type=script&lang=js"
export * from "./LensCreationModal.vue?vue&type=script&lang=js"
import style0 from "./LensCreationModal.vue?vue&type=style&index=0&id=058f169a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058f169a",
  null
  
)

export default component.exports